export const safeJsonStringify = (value: unknown, fallback: string): string => {
  try {
    const result = JSON.stringify(value);
    return typeof result === 'string' ? result : fallback;
  } catch (_) {
    return fallback;
  }
};
